module.exports = __webpack_public_path__ + "assets/e88af9463679b23f5d3d6bd0cf97e831.png";